<div class="container">
	<footer class="footer">
		<div class="footer__load-btn icon icon--down" *ngIf="ifShowLoad && typeDataLoad" (click)="loadData()"></div>
		<share-block class="footer__share"></share-block>
	</footer>
</div>
